import { render, staticRenderFns } from "./newTopic.vue?vue&type=template&id=1626be24&scoped=true&"
import script from "./newTopic.vue?vue&type=script&lang=js&"
export * from "./newTopic.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/newTopic/editInterview.less?vue&type=style&index=0&id=1626be24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1626be24",
  null
  
)

component.options.__file = "newTopic.vue"
export default component.exports